import ReactDatePicker from 'react-datepicker'

import 'react-datepicker/dist/react-datepicker.css'
import { InputCalendar } from '../InputCalendar'

export type DateType = Date | null

type DatePickerProps = {
  startDate: DateType
  endDate: DateType
  onChange: (dates: DateType[]) => void
  size?: 'sm' | 'md'
}

export const DatePicker = (props: DatePickerProps) => {
  const { startDate, endDate, onChange, size = 'md' } = props

  return (
    <ReactDatePicker
      dateFormat="dd/MM/yyyy"
      selectsRange
      selected={startDate}
      startDate={startDate}
      endDate={endDate}
      onChange={onChange}
      enableTabLoop={false}
      customInput={<InputCalendar size={size} />}
    />
  )
}
